<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row class="fill-height" align="center" justify="center">
      <v-col align="center" justify="center" :cols="columns">
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
        <div @click="toggleDialog" style="cursor:pointer">
          <v-img
            src="https://streetcar-east.s3.us-east-2.amazonaws.com/prop+plan+view_08.png"
            style="max-width: 90%;"
          />
        </div>
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
        />
      </v-col>
      <v-col :cols="columns">
        <v-card class="slide-card" style="max-width: 95%;">
          <div class="slide-content">
            <h1 id="header">Proposed Plan Views</h1>
            <p>
              The project team has developed proposed plan views for the
              Streetcar East Extension project. The plan views provide a robust
              picture of the proposed project concept and improvements along the
              project limits in the corridor.
            </p>
            <p>
              <b
                >Click the easel to review the Streetcar East Extension plan
                views and search for a location(s) that may be of interest to
                you along the corridor and refer to the legend to help you
                navigate the display.</b
              >
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="toggled" width="50%">
      <v-card tile flat color="white">
        <v-app-bar dark color="primary" :fixed="true">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="toggled = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <viewer
                :images="rollPlotImages"
                :options="viewerOptions"
                class="images clearfix"
              >
                <template slot-scope="scope">
                  <v-row justify="center">
                    <v-col
                      v-for="obj in scope.images"
                      :key="obj.src"
                      class="d-flex child-flex"
                      :cols="mobileCol"
                    >
                      <v-hover v-slot:default="{ hover }">
                        <v-card
                          :elevation="hover ? 12 : 2"
                          :class="{ 'on-hover': hover }"
                        >
                          <v-card-title
                            v-html="obj.name"
                            class="justify-center"
                          >
                            {{ obj.name }}
                          </v-card-title>
                          <img :src="obj.src" class="image" />
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </template>
              </viewer>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";

export default {
  name: "ProposedPlanViews",
  components: {
    Viewer
  },
  data() {
    return {
      toggled: false,
      rollPlotImages: [
        {
          src:
            "https://streetcar-east.s3.us-east-2.amazonaws.com/Streetcar+East+-+Beltline.png",
          name: "BeltLine Roll Plot"
        },
        {
          src:
            "https://streetcar-east.s3.us-east-2.amazonaws.com/Streetcar+East+-+In-Street.png",
          name: "In-Street Roll Plot"
        }
      ],
      viewerOptions: {
        title: false
      },
      clickedItem: "",
      mouseOverIndex: null,
      showImgModal: false
    };
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "25%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "80%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    },
    mobileCol() {
      if (this.$vuetify.breakpoint.mobile) return "12";
      return 4;
    }
  },
  methods: {
    toggleDialog() {
      this.toggled = !this.toggled;
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    show() {
      this.$viewer.show();
    },
    openModalAndPassIndex(index) {
      this.mouseOverIndex = index;
      this.showImgModal = true;
    },
    closeModalAndNullIndex() {
      this.mouseOverIndex = null;
      this.showImgModal = false;
    }
  }
};
</script>

<style>
.mouse {
  cursor: pointer;
}
.image {
  height: 150px;
  width: 95%;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
